import { useState } from "react";
import { Button, Modal } from "react-bootstrap";

export const FiltroModal = ({ show, handleClose, setFilter }) => {
  const [value, setValue] = useState("");

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setFilter(value);
    handleClose();
  };

  return (
    <Modal
      animation={false}
      show={show}
      onHide={handleClose}
      size="sm"
    >
      <Modal.Header className="d-flex align-items-end" closeButton >
        <div style={{ fontSize: 18 }}>Filtrar por:</div>
      </Modal.Header>
      <Modal.Body>
        <form className="d-flex flex-column p-3" style={{ gap: 10 }} onSubmit={handleSubmit} >
          <div className="d-flex align-items-center" style={{ gap: 10 }} >
            <input
              type="checkbox"
              name="filter"
              onChange={handleChange}
              id="Activos"
              value="Activos"
              className="sn-checkbox"
              checked={value === "Activos"}
            />
            <label htmlFor="Activos" className="sn-label">
              Activos
            </label>
          </div>
          <div className="d-flex align-items-center" style={{ gap: 10 }} >
            <input
              type="checkbox"
              name="filter"
              id="Sin Evaluar"
              value="Sin Evaluar"
              onChange={handleChange}
              className="sn-checkbox"
              checked={value === "Sin Evaluar"}
            />
            <label htmlFor="Sin Evaluar" className="sn-label">
              Sin Evaluar
            </label>
          </div>
          <div className="d-flex align-items-center" style={{ gap: 10 }} >
            <input
              type="checkbox"
              name="filter"
              onChange={handleChange}
              id="Plan de pagos"
              value="Plan de pagos"
              className="sn-checkbox"
              checked={value === "Plan de pagos"}
            />
            <label htmlFor="Plan de pagos" className="sn-label">
              Plan de pagos
            </label>
          </div>
          <div className="d-flex align-items-center" style={{ gap: 10 }} >
            <input
              type="checkbox"
              name="filter"
              onChange={handleChange}
              id="Todos"
              value="Todos"
              className="sn-checkbox"
              checked={value === "Todos"}
            />
            <label htmlFor="Todos" className="sn-label">
              Todos
            </label>
          </div>
          <div className="mt-3">
            <Button
              type="submit"
              className="custom-button"
              disabled={!value}
            >
              Aplicar filtros
            </Button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};